import { Typography, DatePicker, InputNumber } from "antd";
import moment from "moment";

const { Text } = Typography;

interface ConfigSectionProps {
  interestEndDate: string;
  usdRate: number;
  onInterestEndDateChange: (date: string) => void;
  onUsdRateChange: (rate: number) => void;
}

export const ConfigSection = ({
  interestEndDate,
  usdRate,
  onInterestEndDateChange,
  onUsdRateChange,
}: ConfigSectionProps) => (
  <div>
    <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
      <div>
        <Text style={{ display: "block", marginBottom: 6, fontSize: 12, color: "#8c8c8c" }}>
          Хүү тооцсон огноо
        </Text>
        <DatePicker
          value={moment(interestEndDate)}
          onChange={(date) => onInterestEndDateChange(date?.format("YYYY-MM-DD") || moment().format("YYYY-MM-DD"))}
          format="YYYY-MM-DD"
          style={{ width: 160 }}
        />
      </div>
      <div>
        <Text style={{ display: "block", marginBottom: 6, fontSize: 12, color: "#8c8c8c" }}>
          USD-MNT ханш
        </Text>
        <InputNumber
          min={1000}
          max={10000}
          step={1}
          value={usdRate}
          onChange={(value) => onUsdRateChange(value || 3536)}
          style={{ width: 160 }}
        />
      </div>
    </div>
  </div>
);
